<template>
  <v-app>
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="2">
          <v-subheader>شماره سفارش</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="شماره سفارش"
            v-model="orderNumber"
            aria-disabled="true"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>هزینه ارسال</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="هزینه ارسال"
            v-model="shippingPriceAmount"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>مقدار تخفیف</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="مقدار تخفیف"
            v-model="discountAmount"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>مبلغ سفارش</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="مبلغ سفارش"
            v-model="totalPrice"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>وضعیت پرداخت</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="وضعیت پرداخت"
            v-model="isPayed"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>وضعیت ارسال</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="وضعیت ارسال"
            v-model="shipingStatus"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>تلفن</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="تلفن"
            v-model="phone"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>کد پستی</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="کدپستی"
            disabled
            v-model="postalCode"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>ایمیل</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            disabled
            placeholder="ایمیل"
            v-model="email"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>آدرس</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="آدرس"
            disabled
            v-model="address"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row style="justify-content: center; padding-top: 3rem"
        ><span style="font-size: 18px">محصولات</span></v-row
      >
      <v-row style="justify-content: center">
        <v-data-table
          :headers="headers"
          :items="orderItems"
          hide-default-footer
          class="table"
          @page-count="1"
          item-key="mobile"
        >
          <template v-slot:[`item.totalPrice`]="{ item }">
            <span> {{ price(item.totalPrice + item.taxation) }}</span>
          </template>
          <template v-slot:[`item.taxation`]="{ item }">
            <span> {{ price(item.taxation) }}</span>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            <span> {{ price(item.price) }}</span>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary"> ریکوردی یافت نشد </v-btn>
          </template>
        </v-data-table>
        <!-- <v-simple-table style="text-align: center; border: 1px solid">
          <template>
            <thead>
              <tr>
                <th class="text-center">نام محصول</th>
                <th class="text-center">نام فروشگاه</th>
                <th class="text-center">گروه محصول</th>
                <th class="text-center">تعداد</th>
                <th class="text-center">قیمت واحد</th>
                <th class="text-center">قیمت کل</th>
                <th class="text-center">مالیات محصول</th>
              </tr>
            </thead>
            <v-for> </v-for>
            <tbody v-for="(item, i) in orderItems" :key="i">
              <tr>
                <td style="width: 350px" v-text="item.productTitle"></td>
                <td style="width: 100px" v-text="item.providerName"></td>
                <td style="width: 150px" v-text="item.productGroupTitle"></td>
                <td style="width: 50px" v-text="item.quantity"></td>
                <td style="width: 100px" v-text="price(item.price)"></td>
                <td
                  style="width: 100px"
                  v-text="price(item.totalPrice + item.taxation)"
                ></td>
                <td style="width: 100px" v-text="price(item.taxation)"></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table> -->
      </v-row>

      <v-row justify="center" style="padding-top: 3rem">
        <router-link to="/orders">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  created() {
    this.showLoading = true;
    axios
      .get(
        `https://webapi.virdarteb.com/api/OrderItem/GetByOrderId?OrderId=${this.$route.params.id}`
      )
      .then((response) => {
        this.showLoading = false;
        (this.shippingPriceAmount = response.data.data.shippingPriceAmount),
          (this.discountAmount = response.data.data.discountAmount),
          (this.totalPrice = this.price(response.data.data.totalPrice)),
          (this.orderNumber = response.data.data.orderNumber),
          (this.address = response.data.data.address),
          (this.phone = response.data.data.phone),
          (this.postalCode = response.data.data.postalCode),
          (this.email = response.data.data.email),
          (this.isPayed = response.data.data.isPayed),
          (this.paymentType = response.data.data.paymentType),
          (this.shipingStatus = response.data.data.shipingStatus),
          response.data.data.orderItems.map((item) => {
            this.orderItems.push({
              id: item.id,
              quantity: item.quantity,
              price: item.price,
              totalPrice: item.totalPrice,
              orderId: item.orderId,
              productTitle: item.productTitle,
              productGroupId: item.productGroupId,
              productGroupTitle: item.productGroupTitle,
              taxation: item.taxation,
              providerName: item.providerName,
            });
          });
      })
      .catch(() => {
        this.showLoading = false;
      });
  },
  data: () => ({
    id: null,
    shippingPriceAmount: null,
    discountAmount: null,
    totalPrice: null,
    orderNumber: null,
    address: null,
    phone: null,
    postalCode: null,
    email: null,
    isPayed: null,
    paymentType: null,
    shipingStatus: null,
    orderItems: [],
    headers: [
      {
        text: "نام محصول",
        align: "right",
        value: "productTitle",
        sortable: false,
      },
      { text: "گروه محصول", value: "productGroupTitle", sortable: false },
      { text: "تعداد", value: "quantity", align: "center", sortable: false },
      { text: "قیمت واحد", value: "price", align: "center", sortable: false },
      {
        text: "مالیات محصول",
        value: "taxation",
        sortable: false,
        align: "left",
      },
      {
        text: "قیمت کل",
        value: "totalPrice",
        align: "center",
        sortable: false,
      },
    ],
    typeId: 0,
    desserts: [],
    listData1: [],
  }),
  computed: {
    filteredDesserts() {
      return this.desserts.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  methods: {
    getUser() {
      this.$router.push(`/place/hotels/edit`);
    },
    price(number) {
      number += "";
      number = number.replace(",", "");
      const x = number.split(".");
      let y = x[0];
      const z = x.length > 1 ? "." + x[1] : "";
      const rgx = /(\d+)(\d{3})/;

      while (rgx.test(y)) {
        y = y.replace(rgx, "$1" + "," + "$2");
      }

      return y + z + " تومان";
    },
  },
};
</script>
